import { HtmlHTMLAttributes, useEffect } from 'react';
import useStyles from './AccessibilityText.styles';

/** @deprecated The AccessibilityText component is deprecated and will be removed from glu-utilities-react in a future release. Please switch to glu-typography-react. */

const AccessibilityText = ({ children, ...rest }: HtmlHTMLAttributes<HTMLParagraphElement>) => {
  const classes = useStyles();

  useEffect(() => {
    console.warn(
      'The AccessibilityText component is deprecated and will be removed from glu-utilities-react in a future release. Please switch to glu-typography-react.'
    );
  }, []);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <p className={classes.root} {...rest}>
      {children}
    </p>
  );
};

export const AccessibilityTextBase = AccessibilityText;
export default AccessibilityText;
